module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Selena Coppock\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("A natural blonde who is (now) more faithful to her colorist than she has ever been to any boyfriend, Selena Coppock is a standup comedian, storyteller, and writer based in New York City. When not pushing her pro-blonde agenda, Selena can usually be found in a dive bar lamenting the breakup of Guns N' Roses and putting Bob Seger's \"Night Moves\" on the jukebox. This is her first book.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ErfYBp/tc-custom/9780062131829.jpg?1716663321328",
      "alt": "This image is the cover for the book New Rules for Blondes"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("New Rules for Blondes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Writer, comedienne, and full-time Blonde, Selena Coppock offers up adventures, misadventures, and golden-hued nuggets of wisdom in a laugh-out-loud anthem for those of us who really do have more fun. . . .")]), _c('p', [_vm._v("The modern blonde is savvy, wise, confident, capable, and not afraid to laugh at herself when the occasion calls for it. She knows who she is and is prepared to subvert all stereotypes (although she's not above wielding her golden tresses to her advantage), and knows how to be both classy and a little brassy.")]), _c('p', [_vm._v("In the way only a Boston-bred New Yorker who once won \"Best Hair\" in her high school graduating class could, Coppock doles out tongue-in-cheek advice about avoiding hair disasters, the consequences of dating a man who cares a little too much about his own hair product, and so much more in an outrageous essay collection that will have even the staunchest of raven-haired beauties considering a trip to the nearest salon.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins Publisher\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0